// extracted by mini-css-extract-plugin
export default {"ya-map__subtext":"kMfM9R"};